export default __webpack_public_path__ + "static/Henry-d38285f530e2da5f5b0b578d5df7ccbf.jpeg";